import { useAuthStore } from "@persisted-state/auth/auth.store";

export const LICENSE_STATUSES = {
  PENDING: "PENDING",
  AWAITING_MANAGING_DIRECTOR_VERIFICATION: "AWAITING_MANAGING_DIRECTOR_VERIFICATION",
  AWAITING_MANAGING_DIRECTOR_APPROVAL: "AWAITING_MANAGING_DIRECTOR_APPROVAL",
  AWAITING_UPLOAD_RECEIPT: "AWAITING_UPLOAD_RECEIPT",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
};

export const TASK_STATUSES = {
  READY: "READY",
  CLAIMED: "CLAIMED",
  COMPLETED: "COMPLETED",
  CANCELLED: "CANCELLED",
  TERMINATED: "TERMINATED",
};

export const CLAIMABLE_LICENSE_STATUSES = [
  LICENSE_STATUSES.PENDING,
  LICENSE_STATUSES.AWAITING_MANAGING_DIRECTOR_VERIFICATION,
  LICENSE_STATUSES.AWAITING_MANAGING_DIRECTOR_APPROVAL,
];

const isTaskNotClaimed = (taskStatus: string) => taskStatus === TASK_STATUSES.READY;
const isTaskClaimed = (taskStatus: string) => taskStatus === TASK_STATUSES.CLAIMED;

const isTaskOwner = (claimOwnerName: string | null) =>
  claimOwnerName === useAuthStore.getState().user?.preferredUsername;

const isLicenseClaimable = (status: string) => CLAIMABLE_LICENSE_STATUSES.includes(status);

export const canUserClaim = (taskStatus: string, status: string) =>
  isTaskNotClaimed(taskStatus) && isLicenseClaimable(status);

export const canUserUnclaim = (taskStatus: string, claimOwnerName: string | null) =>
  isTaskClaimed(taskStatus) && isTaskOwner(claimOwnerName);

export const canUserReject = (
  taskStatus: string,
  claimOwnerName: string | null,
  licenseStatus: string,
) => isTaskClaimed(taskStatus) && isTaskOwner(claimOwnerName) && isLicenseClaimable(licenseStatus);

export const canUserApprove = (
  taskStatus: string,
  claimOwnerName: string | null,
  licenseStatus: string,
) => isTaskClaimed(taskStatus) && isTaskOwner(claimOwnerName) && isLicenseClaimable(licenseStatus);

export const canUserUploadReceipt = (licenseStatus?: string) =>
  licenseStatus === LICENSE_STATUSES.AWAITING_UPLOAD_RECEIPT;
